<app-header></app-header>
<gs1-loading *ngIf="show && !isTokenPopupOpen"></gs1-loading>
<div id ="content">
  <router-outlet></router-outlet>
</div>
